import React, { useContext, useCallback } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import { FILTER_PRESETS } from 'constants/filters';
import PawIcon from 'components/PawIcon';

export default function FilterPresetButton({
  presetKey, // one of FILTER_PRESETS.*
  label, // short label, e.g. "B&W", "Vintage"
  thumbnailClassName, // extra classes for the inner preview box
  showRecommended = false,
  image = 'natural',
}) {
  const { activeFilter, setActiveFilter, saveHistory } =
    useContext(CanvasContext);

  const isSelected = activeFilter === presetKey;

  const handleClick = useCallback(() => {
    saveHistory();

    setActiveFilter((prev) =>
      prev === presetKey ? FILTER_PRESETS.NONE : presetKey,
    );
  }, [presetKey, setActiveFilter, saveHistory]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex flex-col items-center text-xs focus:outline-none snap-center"
    >
      <div
        className={[
          'relative w-12 h-10 rounded-md border-[2px] flex items-center justify-center select-none transition',
          isSelected
            ? 'border-primary ring-2 ring-primary'
            : 'border-transparent',
        ].join(' ')}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/filters/${image}.jpg`}
          className="w-full h-full rounded-md border border-black"
          alt={label}
        />
        {showRecommended && (
          <div className="bg-black absolute top-0.5 right-0.5 flex items-center justify-center rounded-full bg-black/85 p-0.5">
            <PawIcon className="h-3 w-3 text-white" />
          </div>
        )}
      </div>
      <span
        className={[
          'mt-1 text-[11px] transition',
          isSelected ? 'text-black' : 'text-gray-600',
        ].join(' ')}
      >
        {label}
      </span>
    </button>
  );
}
